import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { Product } from '../product.decorator';
import { PRODUCT_VIEW_SAMPLES_MODAL_CMS_ID } from './modal/product-view-samples-modal.component';
@Component({
    selector: 'product-view-samples',
    templateUrl: './product-view-samples.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule, ICmsClientModule]
})
export class ProductViewSamplesComponent {
    @Input()
    product?: Product;
    cmsModalOpen = PRODUCT_VIEW_SAMPLES_MODAL_CMS_ID;
    get display(): boolean {
        return !!this.product?.familySamples?.length;
    }
}
